import Styles from './ScrollButton.module.scss'
import cx from 'classnames'
import { EmblaCarouselType } from 'embla-carousel'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { usePreviousButton } from 'components/Carousel/usePreviousButton'

interface Props {
  emblaApi: EmblaCarouselType
  size?: 'xs' | 'sm' | 'md'
}

export const PreviousButton = ({ emblaApi, size = 'md' }: Props) => {
  const { isFocusVisible, isDisabled, isPressed, buttonProps, buttonRef } = usePreviousButton({ emblaApi })

  return (
    <button
      ref={buttonRef}
      className={cx(Styles.scrollButton, Styles.left, Styles[size], {
        [Styles.disabled]: isDisabled,
        [Styles.pressed]: isPressed,
        [Styles.focused]: isFocusVisible,
      })}
      disabled={isDisabled}
      aria-label="Previous"
      {...buttonProps}
    >
      <ChevronLeft size={size === 'xs' ? 14 : 28} />
    </button>
  )
}
